import { Partial, Replace } from '@40seas/entities/common';
import { CreateCreditLineDto } from './create.credit-line.dto';
import { SupplierCreditLine } from './credit-line.entity';
import { EditableCreditLineResultSchema } from './credit-line.result';

export class UpdateCreditLineDto extends Partial(
    Replace(CreateCreditLineDto, [
        {
            fieldName: 'result',
            newFieldSchema: EditableCreditLineResultSchema,
        },
    ]),
) {}

export class UpdateSupplierCreditLineDto extends Partial(
    Replace(SupplierCreditLine, [
        {
            fieldName: 'result',
            newFieldSchema: EditableCreditLineResultSchema,
        },
    ]),
) {}
